import React, { useEffect, useState } from "react";
import "./css/footer.css";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const Footer = () => {
  const [content, setContent] = useState({
    brandTitle: "نبض",
    brandHighlight: " كير",
    aboutText:
      "نبض كير شريكك الاستراتيجي في المملكة العربية السعودية. نقدم حلولاً متكاملة لهيئة الغذاء والدواء، وزارة الصناعة، والتخليص الجمركي لضمان نمو أعمالك.",
    socialTwitter: "",
    socialLinkedin: "",
    socialInstagram: "",
    socialWhatsapp: "",
    quickLinks: [
      { path: "/", label: "الرئيسية" },
      { path: "/about", label: "من نحن" },
      { path: "/services", label: "خدماتنا" },
      { path: "/contact", label: "تواصل معنا" },
      { path: "/faq", label: "الأسئلة الشائعة" },
      { path: "/policy", label: "سياسة الاستخدام والخصوصية" },
      { path: "/licenses", label: "التراخيص والاعتمادات" },
      { path: "/certificates", label: "الشهادات" },
    ],
    servicesLinks: [
      { path: "/service/1", label: "هيئة الغذاء والدواء" },
      { path: "/service/2", label: "وزارة الصناعة" },
      { path: "/service/3", label: "التخليص الجمركي" },
      { path: "/service/6", label: "إصدار شهادات سابر" },
      { path: "/service/5", label: "خدمات منصة نَمَا" },
    ],
    addressText: "الرياض، حي العليا، طريق الملك فهد",
    phoneText: "+966573394229",
    emailText: "info@consulting.sa",
    copyrightText: "جميع الحقوق محفوظة © 2026 نبض كير.",
    designerName: "عبدالرحمن الصاوي",
    designerUrl: "https://abdelrahmanelsawy.elsawi.art/",
  });

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/footer`);
        if (!res.ok) return;
        const data = await res.json();
        if (data.footer) {
          setContent((prev) => ({
            ...prev,
            ...data.footer,
          }));
        }
      } catch {
        // fall back to defaults
      }
    };

    fetchFooter();
  }, []);

  const {
    brandTitle,
    brandHighlight,
    aboutText,
    socialTwitter,
    socialLinkedin,
    socialInstagram,
    socialWhatsapp,
    quickLinks,
    servicesLinks,
    addressText,
    phoneText,
    emailText,
    copyrightText,
    designerName,
    designerUrl,
  } = content;

  const quickLinksList = Array.isArray(quickLinks) ? quickLinks : [];
  const servicesLinksList = Array.isArray(servicesLinks) ? servicesLinks : [];

  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row">
          {/* Column 1: About & Logo */}
          <div className="col-lg-4 col-md-6 col-sm-12">
            <div className="footer-widget">
              <Link to="/" className="footer-logo">
                {brandTitle}
                <span>{brandHighlight}</span>
              </Link>
              <p className="footer-desc">{aboutText}</p>
              <div className="social-links">
                {socialTwitter && (
                  <a href={socialTwitter} className="social-icon" target="_blank" rel="noreferrer">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                )}
                {socialLinkedin && (
                  <a
                    href={socialLinkedin}
                    className="social-icon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-linkedin-in"></i>
                  </a>
                )}
                {socialInstagram && (
                  <a
                    href={socialInstagram}
                    className="social-icon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                )}
                {socialWhatsapp && (
                  <a
                    href={socialWhatsapp}
                    className="social-icon"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="fa-brands fa-whatsapp"></i>
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6 col-sm-12">
            <div className="footer-widget">
              <h4>روابط سريعة</h4>
              <ul className="footer-links">
                {quickLinksList.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>
                      <i className="fa-solid fa-angle-left"></i> {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Column 3: Our Services */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="footer-widget">
              <h4>خدماتنا</h4>
              <ul className="footer-links">
                {servicesLinksList.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path}>
                      <i className="fa-solid fa-angle-left"></i> {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Column 4: Contact Info */}
          <div className="col-lg-3 col-md-6 col-sm-12">
            <div className="footer-widget">
              <h4>معلومات التواصل</h4>

              <div className="footer-contact-item">
                <i className="fa-solid fa-location-dot"></i>
                <div>
                  <h6>العنوان</h6>
                  <p>{addressText}</p>
                </div>
              </div>

              <div className="footer-contact-item">
                <i className="fa-solid fa-phone"></i>
                <div>
                  <h6>الهاتف</h6>
                  <p>{phoneText}</p>
                </div>
              </div>

              <div className="footer-contact-item">
                <i className="fa-solid fa-envelope"></i>
                <div>
                  <h6>البريد الإلكتروني</h6>
                  <p>{emailText}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="copyright-text">
                {copyrightText}{" "}
                {designerName && designerUrl && (
                  <>
                    تصميم وتطوير بواسطة{" "}
                    <Link to={designerUrl} target="_blank" rel="noreferrer">
                      {designerName}
                    </Link>
                    .
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;